import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ProductType } from 'Type/ProductList';
import { showPopup } from 'Store/Popup/Popup.action';
import { hideActiveOverlay } from 'Store/Overlay/Overlay.action';
import { showNotification } from 'Store/Notification/Notification.action';
import { goToPreviousNavigationState } from 'Store/Navigation/Navigation.action';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import ProductFaq, { PRODUCT_FAQ_POPUP_ID } from './ProductFaq.component';

const QuestionDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Question/Question.dispatcher'
);

export const mapStateToProps = state => ({
    questionList: state.QuestionReducer.questionList,
    isLoading: state.QuestionReducer.isLoading,
    isSignedIn: state.MyAccountReducer.isSignedIn,
    customer: state.MyAccountReducer.customer,
    customerAttributes: state.ConfigReducer.customerAdditionalAttributes,
    code: state.ConfigReducer.code
});

export const mapDispatchToProps = dispatch => ({
    getSelectedPageProductQuestions: (id, page)  => QuestionDispatcher.then(
        ({ default: dispatcher }) => dispatcher.requestProductQuestions(dispatch, id, page)
    ),
    addQuestion: (fields)  => QuestionDispatcher.then(
        ({ default: dispatcher }) => dispatcher.submitProductQuestion(dispatch, fields)
    ),
    showPopup: payload => dispatch(showPopup(PRODUCT_FAQ_POPUP_ID, payload)),
    showNotification: (type, message) => dispatch(showNotification(type, message)),
    hideActiveOverlay: () => dispatch(hideActiveOverlay()),
    goToPreviousHeaderState: () => dispatch(goToPreviousNavigationState(TOP_NAVIGATION_TYPE))
});

export class ProductFaqContainer extends PureComponent {
    static propTypes = {
        getSelectedPageProductQuestions: PropTypes.func.isRequired,
        product: ProductType.isRequired,
        areDetailsLoaded: PropTypes.bool.isRequired,
        showPopup: PropTypes.func.isRequired,
        showNotification: PropTypes.func.isRequired,
        addQuestion: PropTypes.func.isRequired,
        hideActiveOverlay: PropTypes.func.isRequired,
        goToPreviousHeaderState: PropTypes.func.isRequired
    };

    state = {
        currentPage: 1,
        questionData: {
            question: null,
            name: null,
            email: null,
            sex: null,
            tip_ten: null,
            tip_par: null,
            product_category: null,
            age: null,
            is_private: false,
            is_agreement: false,
            is_subscribed: false
        },
        isLoading: false
    };


    containerFunctions = {
        showPopup: this._showPopup.bind(this),
        onQuestionSubmitAttempt: this.onQuestionSubmitAttempt.bind(this),
        onQuestionSubmitSuccess: this.onQuestionSubmitSuccess.bind(this),
        onQuestionError: this.onQuestionError.bind(this),
        selectPage: this.selectPage.bind(this),
        handleFieldChange: this._handleFieldChange.bind(this)
    };

    componentDidMount() {
        const { product: { id }, getSelectedPageProductQuestions } = this.props;
        const { currentPage } = this.state;
        getSelectedPageProductQuestions(id, currentPage);
    }

    onQuestionSubmitAttempt(_, invalidFields) {
        const { showNotification } = this.props;

        if (invalidFields) {
            showNotification('info', 'Incorrect data! Please check form fields.');
        }

        this.setState({ isLoading: !invalidFields });
    }

    onQuestionSubmitSuccess(fields) {
        const {
            product,
            addQuestion,
            hideActiveOverlay,
            goToPreviousHeaderState,
            showNotification
        } = this.props;

        const { sku: product_sku } = product;

        fields.sku = product_sku;

        addQuestion(fields).then((success) => {
            if (success) {
                this.setState({
                    questionData: {
                        question: null,
                        name: null,
                        email: null,
                        sex: null,
                        tip_ten: null,
                        tip_par: null,
                        product_category: null,
                        age: null,
                        is_private: false,
                        is_agreement: false,
                        is_subscribed: false
                    },
                    isLoading: false
                });

                goToPreviousHeaderState();
                hideActiveOverlay();
            }

            this.setState({ isLoading: false });
        });
    }

    onQuestionError() {
        showNotification('error', 'Question not added.');
        this.setState({ isLoading: false });
    }

    selectPage(page) {
        const { product: { id }, getSelectedPageProductQuestions } = this.props;
        getSelectedPageProductQuestions(id, page);
        this.setState({ currentPage: page });
    }

    _showPopup() {
        const { showPopup } = this.props;
        showPopup({ title: __('Ask the specialists') });
    }

    _handleFieldChange(fieldName, value) {
        this.setState(({ questionData }) => ({
            questionData: { ...questionData, [fieldName]: value }
        }));
    }

    render() {
        const { currentPage, questionData, isLoading } = this.state;
        return <ProductFaq { ...this.props } { ...this.containerFunctions } currentPage={ currentPage } totalPages={ 10 } questionData={ questionData } isLoading={isLoading} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductFaqContainer);
